<template>
  <div>
    <el-row v-loading="fullscreenLoading" style="z-index:0">
      <el-col v-for="item of data" :key="item.id" :xs="24" :sm="12" :md="8" :lg="8">
        <router-link :to="{path:'/merchantshow',query:{id:item.id}}" v-if="item.id">
          <el-card shadow="hover" style="margin: .1rem !important; overflow: hidden;">
            <img v-if="item.img" alt="img" class="Cover" :src="item.img" onerror="this.remove()">
            <div class="C-InfoCard">
              <div class="Content">
                <div class="Title">{{item.title}}</div>
                <div class="Desc">{{item.project}}</div>
                <div class="Location">
                  <div class="Left">
                    <svg-icon icon-class="address" style="fill:#f39"></svg-icon>
                    <span>{{item.cid}}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </router-link>

      </el-col>
    </el-row>
    <div v-if="page">
      <el-card shadow="never" :body-style="{margin: '20px'}" style="margin:0">
        <el-pagination
          :current-page = parseInt(pageNum)
          @current-change="handleCurrentChange"
          background
          layout='prev, slot, next'
          :total="total"
          :page-size = 24
          :pager-count = 5>
          <span style="color: #f39; font-size: 16px; font-weight: bold">{{ pageNum }}</span>
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'merchant_info',
  props: {
    data: {
    },
    fullscreenLoading: {
      type: Boolean,
      default: false
    },
    page: {
      type: Boolean
    },
    total: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    }

  },
  methods: {
    handleCurrentChange (val) {
      this.$router.push({
        path: this.$route.path,
        query: {
          page: val,
          q: this.$route.query.q,
          cid: this.$route.query.cid,
          t: this.$route.query.t
        }
      })
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
img{
  width: 100%;
  height: 100%;
}
.C-InfoCard {
  position: relative;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.Cover {
  margin: 0px 0px 0px 0;
}

.Title {
  color: #333;
  font-size: 16px;
  padding: 0px 0px 0px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-weight: bold;
}

.State {
  padding: 0px 8px 8px 16px;
  color: #999 !important;
  padding-left: 1rem !important;
  padding-bottom: .5rem !important;
  padding-right: .5rem !important;
  display: flex !important;
  font-size: 14px;
}

.svg-icon {
  width: 1.2em;
  height: 1.2em;
  vertical-align: -0.15em;
  fill: currentColor;
}
.Content {
  overflow: hidden;
  width: 100%;
  text-align: left;
}
.Desc {
  overflow: hidden;
  padding-left: 1rem!important;
  padding-right: .5rem!important;
  font-size: 14px;
  text-align: center;
}
.Location{
  padding: 4px 0px 0px 0px;
  font-size: 14px;
  text-align: center;
}
.Left {
  color: #f39;
}
.ad {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/merchant_info.vue